import { memo } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { ProxyBoxInput } from '../../inputs/proxy-input'

type ProxyProps = {
  url: string
  proxy?: string
  activeSubscription?: boolean
  tooltip?: boolean
}

const noop = () => {}

const ProxyBoxWrapperMock = ({
  url,
  activeSubscription,
  translation,
}: ProxyProps & { translation?: string }) => {
  const { t } = useTranslation(translation || 'dashboard')
  const proxyText = t('proxy')

  return (
    <ProxyBoxInput
      value={undefined}
      activeSubscription={activeSubscription}
      url={url}
      text={proxyText}
      onChangeProxy={noop}
    />
  )
}

export const ProxyBoxMock = memo(ProxyBoxWrapperMock)
